export enum GoogleAnalyticsEvent {
    UserChangedDisplayMode = 'user_changed_display_mode',
    UserManuallyStartedTour = 'user_manually_started_tour',
    UserSkipedTourAfterStarting = 'user_skiped_tour_after_starting',
    UserSkipedWelcomeTour = 'user_skiped_welcome_tour',
}